import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '../../../queryClient'
import {
    DashboardConsultantsResponse,
    httpGetDashboardConsultants,
    HttpGetDashboardConsultantsOptions
} from '../http/dashboard.http'

export const useGetDashboardConsultants = (
    params: HttpGetDashboardConsultantsOptions['params'],
    options?: Omit<UseQueryOptions<DashboardConsultantsResponse>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.DASHBOARD_CONSULTANTS, params],
        queryFn: () => httpGetDashboardConsultants({params}),
        ...options
    })
}
